const WINDOW_ON_ERROR_EVENT = '[WINDOW_ON_ERROR_EVENT]';
const WINDOW_ON_ERROR_SOURCE = '[WINDOW_ON_ERROR_SOURCE]';
const WINDOW_ON_ERROR_LINE_NO = '[WINDOW_ON_ERROR_LINE_NO]';
const WINDOW_ON_ERROR_COL_NO = '[WINDOW_ON_ERROR_COL_NO]';
const WINDOW_ON_ERROR_DETAIL = '[WINDOW_ON_ERROR_DETAIL]';

export const setGlobalOnErrorHandler = () => {
  window.onerror = (event, source, lineno, colno, error) => {
    console.error(WINDOW_ON_ERROR_EVENT, event);
    console.error(WINDOW_ON_ERROR_SOURCE, source);
    console.error(WINDOW_ON_ERROR_LINE_NO, lineno);
    console.error(WINDOW_ON_ERROR_COL_NO, colno);
    console.error(WINDOW_ON_ERROR_DETAIL, error);
    return true;
  };
};